<template>
  <div id="host_activity" :class="isFull === 1 ? 'host_activity0 top_information1' : ' host_activity0'">
    <van-nav-bar :title="$t('title.host_activity')" placeholder fixed left-arrow  @click-left="onClickLeft">
        <template #right>
            <img src="../assets/img/host_activity/host_activity_rules.png" alt="" height="20vw" @click="$router.push({path: '/host_activity_rule', query: $route.query})" v-if="type_sex == 2">
        </template>
    </van-nav-bar>
    <van-row>
        <!--顶部-->
        <van-col span="22" offset="1" class="host_activity_earnings">
            <van-col span="24" class="host_activity_earnings_title">{{ $t('column.today_task_earnings') }}</van-col>
            <van-col span="12" class="host_activity_earnings_coin">
                <img src="../assets/img/coin9.png"/> {{ host_activity_day.claim_income }}
            </van-col>
             <!-- <van-col span="12" class="host_activity_earnings_coin">
                <img src="../assets/img/coin11.png"/> 5500
            </van-col> -->
        </van-col>
         <van-col span="22" offset="1" class="host_activity_live_details">
            <img src="../assets/img/host_activity/host_activity_lunbo.png" @click="$router.push({path: '/host_activity_log', query: $route.query})" v-if="type_sex == 2"/>
         </van-col>
         <!--分类-->
        <van-col span="24" class="host_activity_check">
             <van-col span="12" offset="1" @click.native="activityType(1)">
                <van-col span="24" class="host_activity_check_title">{{  $t('column.Regular') }}</van-col>
                <van-col span="2" offset="11" class="host_activity_check_bor"></van-col>
             </van-col>
             <van-col span="10" @click.native="activityType(2)">
                <van-col span="24" class="host_activity_check_title2">{{  $t('column.activity') }}</van-col>
             </van-col>
         </van-col>
        <van-col span="22" offset="1" class="host_activity_live" v-if="type_sex == 2">
            <van-col span="6" class="host_activity_live_title"> {{  $t('column.Live') }} </van-col>
        </van-col>

        <van-col span="22" offset="1" class="host_activity_date" v-if="type_sex == 2">
            <van-col span="22" offset="1" class="host_activity_date_time">{{ date_text }} {{ $t('column.Earnings') }}: <img src="../assets/img/coin9.png"/> <span>{{ host_activity_day.old_target }}</span></van-col>
            <van-col span="22" offset="1" class="host_activity_wage">
                <van-col span="12">
                    <van-col span="24" class="host_activity_wage_left_title">{{ $t('column.hourly_wage')  }}</van-col>
                    <van-col span="24" class="host_activity_wage_left_bottom">
                        {{  $t('column.still_need')  }} <img src="../assets/img/coin9.png"/> <span>{{ upgrade_list.length > upgrade_i ? upgrade_list[upgrade_i].need_coin : '0' }}</span>
                    </van-col>
                </van-col>
                <van-col span="12" class="host_activity_wage_right" style="position: relative;">
                    <div class="host_activity_wage_right_btn" @click="showWagePopover = !showWagePopover">
                        <img src="../assets/img/coin9.png"/> {{ upgrade_list.length > upgrade_i ? upgrade_list[upgrade_i].daily_reward + '/h' : '' }} <van-icon :name="showWagePopover ? 'arrow-up' : 'arrow-down'" />
                    </div>
                    <div v-show="showWagePopover" class="host_activity_wage_popover">
                        <div class="host_activity_wage_popover_arrow"></div>
                        <div class="host_activity_wage_popover_content">
                            <div 
                                v-for="(item, index) in upgrade_list" 
                                :key="index"
                                :class="['host_activity_wage_item', upgrade_i === index ? 'active' : '']"
                                @click="selectWage(index)"
                            >
                                <img src="../assets/img/coin9.png"/> {{ item.daily_reward }}/h
                            </div>
                        </div>
                    </div>
                </van-col>
             </van-col>
            <van-col span="22" offset="1" class="host_activity_sheng">
                <van-col span="8" class="host_activity_sheng_left">
                    <van-col span="24" class="host_activity_sheng_left_img"><img src="../assets/img/coin9.png"/></van-col>
                    <van-col span="24" class="host_activity_sheng_left_name">{{ host_activity_day.daily_reward }}/h</van-col>
                </van-col>
                <van-col span="10" offset="4" class="host_activity_sheng_right">
                    <van-col span="24" class="host_activity_sheng_left_img"><img src="../assets/img/coin9.png"/></van-col>
                    <van-col span="24" class="host_activity_sheng_right_name">{{ upgrade_list.length > upgrade_i ? upgrade_list[upgrade_i].daily_reward + '/h' : '' }}</van-col>
                </van-col>
            </van-col>
            <van-col span="22" offset="1" class="host_activity_type">
               <div class="host_activity_task_completed" v-if="reward_list.length ==0">{{ $t('column.all_collection_completed') }}</div>
                <div class="host_activity_task_item" v-for="(t,i) in reward_list" :key="i" v-else>
                    <div class="host_activity_task_icon">
                        <img src="../assets/img/host_activity/host_activity_time.png" />
                    </div>
                    <div class="host_activity_task_info">
                        <div class="host_activity_task_title">{{ $t('column.daily_live_duration') }}≥ {{ t.date_time }} {{ $t('column.minutes') }}</div>
                        <div class="host_activity_task_progress">({{ t.duration }}/{{ t.date_time }})</div>
                        <div class="host_activity_task_desc" v-if="t.new_host">{{ $t('column.only_count_duration_solo_live') }}</div>
                        <div class="host_activity_task_reward">
                            <img src="../assets/img/coin9.png" /> <span>+{{ t.daily_reward }}</span>
                        </div>
                    </div>
                    <div class="host_activity_task_btn host_activity_task_status0" v-if="t.claim_status == 0" @click="claimBtn(t)">
                        <div class="host_activity_task_btn_text">{{ $t('column.receive') }}</div>
                    </div>
                    <div class="host_activity_task_btn host_activity_task_status1" v-else-if="t.claim_status ==1">
                         <div class="host_activity_task_btn_text">{{ $t('column.received') }}</div>
                    </div>
                    <div class="host_activity_task_btn host_activity_task_status2" @click="claimJump" v-else>
                          <div class="host_activity_task_btn_text">{{ $t('column.go') }} <van-icon name="arrow" size="10"/></div>
                    </div>
                </div>
               
            </van-col>
        </van-col>
        <van-col class="countdown_fixed" v-if="type_sex == 2">
            <div class="countdown_wrapper">
                <van-icon name="clock-o" />
                <van-count-down :time="countdown_time" format="HH:mm:ss" />
            </div>
        </van-col>

        <van-popup v-model="showCongrats" :style="{ background: 'transparent' }">
            <div class="congrats-container">
                <img src="../assets/img/host_activity/congratulations.png" class="congrats-bg" />
                <div class="congrats-content">
                    <!-- 在这里添加文字和图片内容 -->
                    <div class="congrats-text">{{ $t('column.Congratulations') }}</div>
                    <!-- 示例图片：<img src="..." /> -->
                    <div class="congrats-content-bg">
                      <div class="congrats-content-bg_img">
                         <img src="../assets/img/coin9.png" />
                      </div>
                      <div class="congrats-content-bg_name">x{{ CongratsCoin }}</div>
                    </div>
                    <div class="congrats-content-btn" @click="showCongrats = false">{{ $t('btn.confirm') }}</div>
                </div>

            </div>
        </van-popup>
        
        <van-overlay :show="loading" z-index="2003">
            <van-loading type="spinner" class="loading_overlay"/>
        </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data() {
    return {
      loading: false,
      showCongrats: false,
      CongratsCoin:0,
      finished: false,
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      showWagePopover: false,
      date_text: '',
      host_activity_day:{
        old_target: 0,
        claim_income:0,
        daily_reward:0
      },
      date_coin: 0,
      upgrade_list: [],
      upgrade_i: 0,
      reward_list: [],
      countdown_time: 0, // 距离今日结束的倒计时毫秒数
      type_sex:1, //1男2女
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
    activityType(type){
      if(type == 2){
        Toast('coming soon')
      }
    },
    claimBtn(t){
       // on confirm
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=host_activity&act=claim_activity_reward",{
        params:{token: token, hours_i:t.id, activity_id:t.activity_id }
      }).then(res =>{
        this.loading = false
        if (res.data.status === 1) {
           this.CongratsCoin = res.data.data.money
            this.showCongrats = true
            this.get_list()
        }else{
          Toast(res.data.error)
        }
      }).catch(err => {
        this.loading = false
      })
    },
    claimJump() {
      // 拦截跳转->开始直播
      window.location.href="live://live?action=OpenLive"
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    selectWage(index) {
      this.upgrade_i = index
      this.showWagePopover = false
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=host_activity&act=host_activity_center",{ params:{token: token }}).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          this.date_text = res.data.data.date
          this.host_activity_day = res.data.data.host_activity_day
          this.date_coin = res.data.data.date_coin
          this.upgrade_list = res.data.data.upgrade_list
          this.upgrade_i = res.data.data.upgrade_i
          this.reward_list = res.data.data.reward_list
          this.type_sex = res.data.data.sex
          this.countdown_time = res.data.data.countdown_time
          this.finished = true
          this.loading = false
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/host_activity.vue